import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Modal, Select } from 'antd'
import { useDispatch } from 'react-redux'
import styled from 'styled-components/macro'
import { unreconcileInvoiceFromPO } from '../../features/NewInvoicesSlice'
import { getUnreconcileActionMeta } from '../../utils/invoiceUnreconcileActionHelpers'

const { Option } = Select

const UnreconcileInvoiceModal = ({ open, invoice, venueId, onClose }) => {
  const dispatch = useDispatch()
  const meta = useMemo(() => getUnreconcileActionMeta(invoice || {}), [invoice])
  const [selectedPo, setSelectedPo] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!open) {
      setSelectedPo('')
      setSubmitting(false)
      return
    }
    setSelectedPo(meta.defaultPurchaseOrderNumber || '')
  }, [open, meta.defaultPurchaseOrderNumber, invoice?.id, invoice?._id])

  const invoiceId = invoice?.id || invoice?._id

  const handleOk = async () => {
    if (!invoiceId || !venueId) return
    if (meta.needsPoSelection && !String(selectedPo || '').trim()) {
      return
    }

    setSubmitting(true)
    try {
      await dispatch(
        unreconcileInvoiceFromPO(invoiceId, {
          venueId,
          purchaseOrderNumber: meta.needsPoSelection ? selectedPo : '',
        }),
      )
      // if (result) {
      //   onSuccess?.(result)
      //   onClose?.()
      // }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title='Unreconcile invoice'
      visible={open}
      onOk={handleOk}
      onCancel={() => {
        if (!submitting) onClose?.()
      }}
      okText='Unreconcile'
      cancelText='Cancel'
      confirmLoading={submitting}
      okButtonProps={{
        disabled: meta.needsPoSelection && !String(selectedPo || '').trim(),
      }}
      destroyOnClose
    >
      <ModalBody>
        <p>{meta.confirmCopy}</p>

        {meta.xeroWarning ? (
          <Alert type='warning' showIcon message={meta.xeroWarning} />
        ) : null}

        {meta.needsPoSelection ? (
          <PoField>
            <label htmlFor='unreconcile-po-select'>Purchase order</label>
            <Select
              id='unreconcile-po-select'
              showSearch
              placeholder='Select purchase order to unreconcile'
              optionFilterProp='children'
              value={selectedPo || undefined}
              onChange={value => setSelectedPo(value)}
              style={{ width: '100%' }}
            >
              {meta.reconciledPurchaseOrderNumbers.map(po => (
                <Option key={po} value={po}>
                  {po}
                </Option>
              ))}
            </Select>
          </PoField>
        ) : null}
      </ModalBody>
    </Modal>
  )
}

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const PoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
`

export default UnreconcileInvoiceModal
